/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Nav_DemandInputs */

const cs_public_site_nav_demand = /** @type {(inputs: Public_Site_Nav_DemandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávka`)
};

const en_public_site_nav_demand = /** @type {(inputs: Public_Site_Nav_DemandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demand`)
};

/**
* | output |
* | --- |
* | "Demand" |
*
* @param {Public_Site_Nav_DemandInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_nav_demand = /** @type {((inputs?: Public_Site_Nav_DemandInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Nav_DemandInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_nav_demand(inputs)
	return cs_public_site_nav_demand(inputs)
});